import { render, staticRenderFns } from "./newTask.vue?vue&type=template&id=e6e9f94a&scoped=true&"
import script from "./newTask.vue?vue&type=script&lang=js&"
export * from "./newTask.vue?vue&type=script&lang=js&"
import style0 from "./newTask.vue?vue&type=style&index=0&id=e6e9f94a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e9f94a",
  null
  
)

component.options.__file = "newTask.vue"
export default component.exports